import React from "react";
import { useState } from "react";
import useIsMobile from "../../../js/utilities/useIsMobile";
import { useEffect } from "react";
import { FOOTER_CONTACTS } from "../data/contacts";
import { Icon } from "@iconify/react";
import * as _ from "lodash";
import { useTranslations } from "../../../hooks/use-translations";
import { useLanguage } from "../../../hooks/use-language";

/**
 * Componente de la lista de contactos en el footer.
 * @returns {JSX.Element} Componente ContactList.
 */
export const ContactList = () => {
	const contactList = [...FOOTER_CONTACTS];
	return (
		<div className="contact-section row p-0 m-0 pb-3">
			{contactList?.map((contactData, i) => {
				return (
					<div key={i} className="col-12 col-lg-6 col-xl-6 p-0">
						<ContactCard key={i} data={contactData} />
					</div>
				);
			})}
		</div>
	);
};

/**
 * Componente de una tarjeta de contacto en el footer.
 * @param {object} props 
 * @param {object} props.data 
 * @param {string} props.data.title 
 * @param {string} props.data.title.translationPath 
 * @param {string} props.data.title.default 
 * @param {object} props.data.emails 
 * @param {string} props.data.emails.contactName 
 * @param {string} props.data.emails.email 
 * @param {string} props.data.emails.website 
 * @param {object} props.data.contactNumbers 
 * @param {string} props.data.contactNumbers 
 * @param {object} props.data.adresses 
 * @param {string} props.data.adresses 
 * @returns {JSX.Element} Componente ContactCard.
 */
export const ContactCard = ({ data }) => {
	const lang = useLanguage();
	const texts = useTranslations({ section: "footer", lang: lang });
	const [expanded, setExpanded] = useState(false);
	const isMobile = useIsMobile();

	const title = _.get(texts, data?.title?.translationPath) || data?.title?.default || "N/A";
	const emails = Array.isArray(data?.emails) ? data?.emails : [];
	const contactNumbers = Array.isArray(data?.contactNumbers) ? data?.contactNumbers : [];
	const adresses = Array.isArray(data?.adresses) ? data?.adresses : [];

	useEffect(() => {
		if (isMobile === false) {
			setExpanded(true);
		} else {
			setExpanded(false);
		}
	}, [isMobile]);

	const handleMobileExpandedState = (_expanded) => {
		if (isMobile) {
			setExpanded(_expanded);
		}
	};

	return (
		<div className="contact-card p-2">
			<h3
				className="title d-flex justify-content-between"
				style={{ cursor: isMobile ? "pointer" : "default" }}
				role={`${isMobile ? "button" : "none"}`}
				aria-label={`${title} ${expanded ? "expandido/expanded" : "contraido/collapsed"}`}
				onClick={() => handleMobileExpandedState(!expanded)}
			>
				<span>{title}</span>

				<Icon
					className={`dropdown-arrow-transition ${isMobile === false && "d-none"} ${
						expanded ? "expanded-dropdown" : "collapsed-dropdown"
					}`}
					icon="fe:arrow-down"
					width={"1.5em"}
				/>
			</h3>
			<div className={`info ${expanded ? "d-block" : "d-none"}`} style={{ maxWidth: 300 }}>
				<ul className={`my-2`}>
					{emails?.map((email, i) => {
						return (
							<li key={i}>
								{email?.website ? (
									<a
										className="info font-weight-bold default-link d-block"
										href={email.website}
										target="_blank"
										rel="noopener noreferrer"
									>
										{email?.contactName}
									</a>
								) : (
									<p className="info font-weight-bold">{email?.contactName}</p>
								)}
								<a
									className="info font-weight-bold default-link focusable-secondary"
									href={`mailto:${email?.email}`}
								>
									{email?.email}
								</a>
							</li>
						);
					})}
				</ul>
				<ul className="my-2">
					{contactNumbers?.map((contact, i) => {
						return (
							<li key={i}>
								<p className="">{contact}</p>
							</li>
						);
					})}
				</ul>
				<ul className="my-2">
					{adresses?.map((adress, i) => {
						return (
							<li key={i}>
								<p className="info font-weight-normal">{adress}</p>
							</li>
						);
					})}
				</ul>
			</div>
		</div>
	);
};
